import { Component, OnInit } from '@angular/core';
import { NotificationType } from 'src/app/models/notification.message';
import { LocationRequest } from 'src/app/models/requests/location-request';
import { LocationsService } from 'src/app/services/locations.service';
import { NotificationService } from 'src/app/services/notification.service';

@Component({
  selector: 'app-new-location',
  templateUrl: './new-location.component.html',
  styleUrls: ['./new-location.component.css']
})
export class NewLocationComponent {

  name: string = '';
  description: string = '';


  constructor(private locationService: LocationsService, private notification: NotificationService) { }

  
  onSubmit(): void {
    let LocationVm: LocationRequest = {
      name: this.name,
      description: this.description,
    };

    this.locationService.saveLocation(LocationVm).subscribe({
      next: (data => {
        
        if (data.responseCode == "00") {
          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.success
          });

          console.debug(`Location Created successfully ${data}`);
          this.description = '';
          this.name = ''

        }
        else {

          this.notification.sendMessage({
            message: data.message,
            type: NotificationType.error
          });

        }

      }),
      error: ((error: any) => {
        console.log(error.error);
        ;


        this.notification.sendMessage({
          message: error.error.message,
          type: NotificationType.error
        });
      })

    });
  }
}
